
import { setSocket, SettingsState } from '../Store/Settings';
import { io } from "socket.io-client";

/* This setup has so far been the most dependable for me regarding
   sockets waking up when you leave your laptop and come back. I do
   believe there are still times it won't come back, so I am just going
   to have to monitor it and figure it out as we go. av 6/9/25
 */

export const openSocket = (dispatch: any, settingsState: SettingsState) => {

    if (!settingsState.socket) {
        console.log("socket not in state");
        return newSocket(dispatch);
    } else {
        if (!settingsState.socket.connected) {
            settingsState.socket.disconnect();
            settingsState.socket.close(); // <- this helps make absolutely sure
            settingsState.socket.removeAllListeners();
            console.log("Socket disconnected? " + !settingsState.socket.connected);
            console.log("socket in state, but not connected");
            settingsState.socket.connect();
            console.log("Socket connected? " + settingsState.socket.connected);
            return newSocket(dispatch);
        } else {
            console.log("socket is connected");
            return settingsState.socket;
        }
    }
  }

  const newSocket = (dispatch: any) => {
    /* We use websocket because if not it will do long polling and 
        fire a connect / disconnect thousands of times per second
        in the node.js server */
        //console.log(process.env.REACT_APP_BACKEND_URL);
    let socket = io(process.env.REACT_APP_BACKEND_URL, {
        transports: ["websocket"],
        forceNew: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        autoConnect: true, // this is OK
        withCredentials: true, // send cookies
    });
    console.log("opening new socket");
    console.log(socket);
    dispatch(setSocket(socket));
    return socket;
  }